/* eslint-disable prefer-destructuring, no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { lineUpSounds } from '@/utils/sounds';
import { DEVICE } from '@/constants';
import { OS } from '@/utils/detectDevice';
import Word from '../Word';
import './style.less';

// 被拖动div
let dv = null;
// 是否可以检验
let check = false;
// transition执行次数
let transitionNum = 0;

class LineUp extends Component {
  static propTypes = {
    finished: PropTypes.func,
    exercisesData: PropTypes.object,
    changeBtn: PropTypes.func,
    retryBtn: PropTypes.func,
    url: PropTypes.string,
    audioStop: PropTypes.func,
    audioPlay: PropTypes.func,
    soundsUrl: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      show: true,
      audio: '',
      wordData: '',
      answer: '',
      playing: false,
    };
    this.wordRef = React.createRef();
    this.wordList = React.createRef();
    this.rightSpan = React.createRef();
    this.lineUpWrapper = React.createRef();
  }

  componentDidMount() {
    const { exercisesData, url } = this.props;
    this.init(exercisesData, url);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.url !== this.props.url && this.init(nextProps.exercisesData, nextProps.url);
  }

  init = (exercisesData, url) => {
    const match = exercisesData.root[0].tasks[0].task[0].matches[0].match;
    const Data = [];
    match.forEach((item) => {
      Data.push({
        val: item._attr.text._value,
        audio: item._attr.audio ? `${url}OM/${item._attr.audio._value}.ogg` : '',
      });
    });
    const answerData = [...Data];
    this.arrRandom(Data);
    this.setState({
      wordData: Data,
      audio: exercisesData.root[0].tasks[0].task[0]._attr.audio && `${url}OM/${exercisesData.root[0].tasks[0].task[0]._attr.audio._value}.ogg`,
      answer: answerData,
    });
  }

  handleCheck = () => {
    let isRight = true;
    let answer = '';
    this.wordList.current.childNodes.forEach((item, index) => {
      dv = document.getElementById(item.id);
      item.childNodes[1].innerText !== this.state.answer[index].val
        && (isRight = false);
      answer += `${this.state.answer[index].val} `;
    });
    check = false;
    if (isRight) {
      this.rightSpan.current.innerText = answer;
      this.wordList.current.style.display = 'none';
      this.props.audioPlay(`${this.props.soundsUrl}${lineUpSounds.allRight}`, { type: 'exercise' });
      this.audioEnd();
      this.props.finished();
      this.props.retryBtn(true);
    } else {
      this.props.changeBtn(true);
      this.handleWrong();
    }
  }

  handleRetry = () => {
    this.wordList.current.style.display = 'block';
    this.rightSpan.current.innerHTML = '';
    this.wordList.current.innerHTML = '';
    check = false;
    this.props.changeBtn(true);
    this.props.retryBtn(false);
    this.setState({ show: false }, () => {
      this.setState({ show: true });
    });
  }

  switchAudio = () => {
    const { playing, audio } = this.state;
    !playing ? this.props.audioPlay(audio, { type: 'exercise', index: 0 }) : this.props.audioStop();
  }

  handleSounds = () => {
    const { soundsUrl } = this.props;
    this.props.audioPlay(`${soundsUrl}${lineUpSounds.handle}`, { type: 'exercise', index: -1 });
    OS.TYPE === DEVICE.PC && this.audioEnd();
  }

  readWords = (src) => {
    this.props.audioPlay(src, { type: 'exercise', index: -1 });
    this.audioEnd();
  }

  audioPlay = (data) => {
    data.index === 0 && this.setState({ playing: true });
  }

  audioEnd = () => this.setState({ playing: false });

  handleWordMouseup = (word, x, y, oldx) => {
    dv = word;
    const dvR = x + dv.clientWidth;
    const dvB = y + dv.clientHeight;
    // 可视窗口上下左右距离
    const container = this.lineUpWrapper.current;
    const conT = container.offsetTop;
    const conB = conT + container.clientHeight;
    const conL = container.getBoundingClientRect().left;
    const conR = container.clientWidth;
    dv.className = dv.className.replace('down', '');
    if (!check) {
      // 在单词摆放区域添加否则回到原来位置
      if ((y > conT && dvB < conB
        && x > conL && dvR < conR)) {
        dv.className = 'word';
        this.wordList.current.appendChild(dv);
        this.wordList.current.childNodes.length === this.state.wordData.length
          && (check = true) && this.props.changeBtn(false);
      }
      dv.style.left = `${dv.offsetLeft}px`;
      dv.style.top = `${dv.offsetTop}px`;
    } else {
      this.handleSort(oldx, x, y);
    }
  }

  handleSort = (oldx, x, y) => {
    let sort = false;
    this.wordList.current.childNodes.forEach((item) => {
      if (dv.id !== item.id && !sort) {
        const itemLeft = parseInt(item.style.left.replace('px', ''), 10);
        const itemTop = parseInt(item.style.top.replace('px', ''), 10);
        if (x < oldx) {
          // 往前排序
          if (x <= itemLeft && y <= itemTop + item.clientHeight) {
            this.wordList.current.insertBefore(dv, item);
            sort = true;
          }
          // 往后排序
        } else if ((x + dv.clientWidth <= itemLeft + item.clientWidth - dv.clientWidth)
          && y <= itemTop + item.clientHeight) {
          this.wordList.current.insertBefore(dv, item);
          sort = true;
        }
        // 重新定位
        this.handlePosition();
      }
    });
    if (!sort) {
      this.wordList.current.appendChild(dv);
      // 重新定位
      this.handlePosition();
    }
  }

  handlePosition = () => {
    this.wordList.current.childNodes.forEach((item) => {
      const itemdv = document.getElementById(item.id);
      itemdv.style.left = `${item.offsetLeft}px`;
      itemdv.style.top = `${item.offsetTop}px`;
    });
  }

  handleWrong = () => {
    // 掉下来
    this.wordList.current.childNodes.forEach((item, index) => {
      const wordShadow = document.getElementById(`wordShadow${item.id.replace(/[^0-9]/ig, '')}`);
      const word = document.getElementById(item.id);
      word.className = 'word position animation';
      word.style.left = `${wordShadow.offsetLeft}px`;
      word.style.top = `${wordShadow.offsetTop}px`;
      index === this.wordList.current.childNodes.length - 1
        && word.addEventListener('transitionend', this.handleTransitionend);
    });
  }

  handleTransitionend = () => {
    // 放大缩小
    transitionNum += 1;
    transitionNum === 2 && this.wordList.current.childNodes.forEach((item, index) => {
      const word = document.getElementById(item.id);
      word.className = 'word position animation1';
      transitionNum = 0;
      word.removeEventListener('transitionend', this.handleTransitionend);
      index === this.wordList.current.childNodes.length - 1
        && word.addEventListener('animationend', this.handleAnimationend);
    });
  }

  handleAnimationend = () => {
    this.handleRetry();
  }

  handleParseInt = val => parseInt(val.replace('px', ''), 10);

  arrRandom = (wordData) => {
    const arr = wordData;
    arr.sort(() => Math.random() - 0.5);
  }

  render = () => {
    const { wordData, audio, playing } = this.state;
    return (
      <div className="line-up-container">
        <div className="line-up-wrapper" ref={this.lineUpWrapper}>
          {audio && <div className={`line-up-play${playing ? ' playing' : ''}`} onClick={this.switchAudio} />}
          <div className="right-span" ref={this.rightSpan} />
          <div className="word-wrapper" ref={this.wordList} />
        </div>
        <div className="snow1" />
        <div className="snow2" />
        <div className="snow3" />
        <div className="snow4" />
        <div className="word-wrapper">
          {this.state.show && wordData
            && wordData.map((item, index) => (
              <div className="word-shadow" id={`wordShadow${index}`} key={`word-shadow${index + 1}`}>
                <Word
                  index={index}
                  item={item}
                  mouseup={this.handleWordMouseup}
                  ref={this.wordRef}
                  handleSounds={this.handleSounds}
                  readWords={this.readWords}
                />
              </div>
            ))
          }
        </div>
        <audio src={audio} ref={this.audio} />
      </div>
    );
  }
}

export default LineUp;
